import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDescriptionDLogic } from './hooks/useNonprofitDescriptionDLogic';
import { NonprofitDescriptionDForm } from './NonprofitDescriptionDForm';

export const EddNonprofitDescriptionD = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDescriptionDLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDescriptionD.content')}
        textCustomStyle='text-text-main-primary text-[16px] whitespace-pre-line'
        content={t('organic.nonprofitDescriptionD.title')}>
        <NonprofitDescriptionDForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
